import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { phoneNumberMasker } from "react-common-ui-library";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { SPAN } from "../../Constants/CommonConstants";
import {
  EMAIL_ADDRESS,
  PHONE_NUMBER,
  PREFERRED_METHOD_EMAIL,
  VERIFY_ACCOUNT_OTP_LABEL,
  VERIFY_ACCOUNT_OTP_LABEL_EMAIL,
  VERIFY_ACCOUNT_OTP_LABEL_EMAIL_ADDRESS,
  VERIFY_ACCOUNT_OTP_LABEL_PHONE,
  VERIFY_ACCOUNT_OTP_LABEL_PHONE_NUMBER,
} from "../../Constants/VerifyAccountConstants";
import { manageVerificationSelector } from "../../Selectors/VerificationSelector";
import { emailMasker } from "./VerifyAccountUtils";

/**
 * @description Displays the Verify Account OTP Input Field
 * @param {string} previousScreen specifies the previous screen for verify account
 * @param {string} selectedVerificationMethod specifies the selected verification method
 * @returns {ReactNode} Renders the Verify Account OTP input field label
 */
export const VerifyAccountOTPLabel = ({
  selectedVerificationMethod,
  previousScreen,
}) => {
  const intl = useIntl();
  const { email, phoneNo } = useSelector((state) =>
    manageVerificationSelector(state, previousScreen)
  );

  return (
    <Typography id={VERIFY_ACCOUNT_OTP_LABEL}>
      {intl.formatMessage(
        { id: VERIFY_ACCOUNT_OTP_LABEL },
        {
          preferredMethod: (
            <Box
              component={SPAN}
              id={
                selectedVerificationMethod === PREFERRED_METHOD_EMAIL
                  ? VERIFY_ACCOUNT_OTP_LABEL_EMAIL
                  : VERIFY_ACCOUNT_OTP_LABEL_PHONE
              }
            >
              {selectedVerificationMethod === PREFERRED_METHOD_EMAIL
                ? intl.formatMessage({ id: EMAIL_ADDRESS })
                : intl.formatMessage({ id: PHONE_NUMBER })}
            </Box>
          ),
          contactDetail: (
            <Box
              component={SPAN}
              id={
                selectedVerificationMethod === PREFERRED_METHOD_EMAIL
                  ? VERIFY_ACCOUNT_OTP_LABEL_EMAIL_ADDRESS
                  : VERIFY_ACCOUNT_OTP_LABEL_PHONE_NUMBER
              }
            >
              {selectedVerificationMethod === PREFERRED_METHOD_EMAIL
                ? emailMasker(email)
                : phoneNumberMasker(phoneNo, true)}
            </Box>
          ),
        }
      )}
    </Typography>
  );
};

VerifyAccountOTPLabel.propTypes = {
  /**
   * specifies the previous screen
   */
  previousScreen: PropTypes.string.isRequired,
  /**
   * specifies the previous screen
   */
  selectedVerificationMethod: PropTypes.string.isRequired,
};
